import type { PortalConfig } from '@shared/config';

export const lexwooConfig: PortalConfig = {
  id: 'lexwoo',

  // LexWoo shows only WOO cases
  includePortals: ['lexwoo'],

  branding: {
    name: 'LexWoo',
    tagline: 'De exclusieve database voor WOO professionals',
    rechtsgebiedNaam: 'Woo',
    rechtsgebiedBeschrijving: 'Dagelijkse nieuwsbrief met hoogwaardige samenvattingen van Wet open overheid uitspraken en intelligente zoekmachine om juiste jurisprudentie te vinden.',
    contactEmail: 'info@lexlabour.nl',
    contactFormRecipient: 'remco.volmer@riverwise.nl',
    linkedInUrl: 'https://www.linkedin.com/company/lexwoo',
    domain: 'lexwoo.nl',
  },

  colors: {
    primary: 'oklch(0.45 0.16 252)',        // Blue theme - darker, more professional
    primaryHover: 'oklch(0.40 0.14 252)',   // Darker blue
    secondary: 'oklch(0.22 0.15 270)',      // Deep blue-purple
    themeColor: '#1e40af',                  // Blue-800 - darker, more professional
  },

  assets: {
    logo: '/lexwoo_logo.svg',
    logoSmall: '/lexwoo_logo_small.svg',
    logoHeight: 'h-11', // Larger height to compensate for wide viewBox
  },

  storage: {
    themeKey: 'lexwoo-theme',
    searchStoreKey: 'lexwoo-search',
  },

  newsletter: {
    dailySendTime: '18:00',
    weeklySendDay: 'woensdag',
    weeklySendTime: '12:30',
  },

  partnership: {
    label: 'LexWoo is een samenwerking van Riverwise en NKOO',
    partners: [
      { name: 'Riverwise', logo: '/riverwise_logo.png', url: 'https://riverwise.nl' },
      { name: 'NKOO', logo: '/nkoo_logo.png', logoHeight: 'h-5', url: 'https://nkoo.nl' },
    ],
  },

  scraper: {
    rechtsgebiedUri: 'http://psi.rechtspraak.nl/rechtsgebied#bestuursrecht',
    keywords: 'wet open overheid|wet openbaarheid bestuur',
  },
};
